import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { Component, ViewEncapsulation } from '@angular/core';
import { VcnRoutes } from '../../../vcn-routes.constants';
import { Router } from '@angular/router';

@Component({
  selector: 'app-side-bar-hors-formation',
  templateUrl: './side-bar-hors-formation.component.html',
  styleUrls: ['./side-bar-hors-formation.component.css'],
  animations: [
    trigger('slideToggle', [
      state('open', style({ height: '*', opacity: 1, overflow: 'hidden' })),
      state('closed', style({ height: '0px', opacity: 0, overflow: 'hidden' })),
      transition('open <=> closed', [animate('300ms ease-in-out')]),
    ]),
  ],
  encapsulation: ViewEncapsulation.None,
})
export class SideBarHorsFormationComponent {
  constructor(private router: Router) {}
  user: any | null;
  profil: any;
  logged: any;
  role!: any;
  cohorte!: string;
  nomrole!: string;

  vcnRoute = VcnRoutes;
  showdashboard: string = 'ok';
  urlScholarVox = 'https://skills.scholarvox.com/forcen';

  ngOnInit() {
    this.user = sessionStorage.getItem('user');
    this.logged = sessionStorage.getItem('logged');
    this.profil = JSON.parse(this.user).profile.id;

    this.role = JSON.parse(this.user)?.roles;
    // console.log('roles : ', this.role);
    this.cohorte = JSON.parse(
      this.user
    ).beneficiaryCohortes[0]?.cohorte.cohorteName;

    // console.log('user role: ', this.user);
  }
  reloadComponent(self: boolean, urlToNavigateTo?: string) {
    //skipLocationChange:true means dont update the url to / when navigating
    const url = self ? this.router.url : urlToNavigateTo;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([`/${url}`]).then(() => {
        // console.log(`After navigation I am on:${this.router.url}`);
      });
    });
  }

  openUrl(url: string) {
    window.open(url, '_blank');
  }
}
